import { inject, Injectable } from '@angular/core'
import { Observable, catchError, combineLatestWith, of, switchMap, take } from 'rxjs'
import { AppFacade } from '@appShared/services/app.facade'

@Injectable({ providedIn: 'root' })
export class AppConfigProvider {
   private _appFacade = inject(AppFacade)

   init(): Observable<boolean> {
      console.log('init', (new Date()).getTime())
      return this._appFacade.initializeSite().pipe(
         take(1),
         switchMap(() => of(true)),
         catchError((err) => {
            console.log('Error occurred loading site config:', err)
            return of(false)
         })
      )
   }
}
